import { forwardRef } from "react";
import { cn } from "~/lib/utils";
import { ChevronRightIcon } from "~/components/icons";

export interface ActionButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  title: string;
  description: string;
  icon: React.ReactNode;
  href?: string;
}

const ActionButton = forwardRef<HTMLButtonElement, ActionButtonProps>(
  ({ className, title, description, icon, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={cn(
          "group flex w-full items-center justify-between border-b border-[rgba(0,0,45,0.09)] bg-white/80 px-3 py-4 transition-all hover:bg-[#f9f9fb] last:border-b-0",
          "cursor-pointer active:scale-[0.99] active:bg-[#f0f0f4]",
          "focus:outline-none focus:ring-2 focus:ring-[#003261] focus:ring-offset-1",
          className
        )}
        {...props}
      >
        <div className="flex items-center gap-3">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-[rgba(0,116,221,0.09)] bg-[rgba(0,85,199,0.04)]">
            {icon}
          </div>
          <div className="flex flex-col items-start gap-0.5">
            <p className="text-base leading-6 text-[#1c2024]">
              {title}
            </p>
            <p className="text-sm leading-5 text-[#60646c]">
              {description}
            </p>
          </div>
        </div>
        <ChevronRightIcon className="h-5 w-5 shrink-0 text-[#60646c] transition-transform group-hover:translate-x-0.5" />
      </button>
    );
  }
);

ActionButton.displayName = "ActionButton";

export { ActionButton };

